const presetElements = [
  {
    type: 'switch',
    element: 'el-switch'
  },
  {
    type: 'switch-disabled',
    element: 'el-switch',
    attrs: {
      disabled: true
    }
  }
]

export default presetElements
